import {
  Backdrop,
  Button,
  Checkbox,
  Chip,
  FormControlLabel,
  Grid,
  IconButton,
  Switch,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import * as yup from "yup";
import CustomDataGrid from "../../../../../components/dataTable/customDataGrid";
import CustomdropDown from "../../../../../components/utils/dropDown/customdropDown";
import CustomTextField from "../../../../../components/utils/input/customTextField";
import Modal from "../../../../../components/utils/modal/modal";
import { useDispatch } from "react-redux";
import axios from "axios";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { Delete, EditNote } from "@mui/icons-material";
import DeletePage from "../../../../../components/utils/deleteModal/deletePage";
import _ from "lodash";
import Loader from "../../../../../components/loader/loader";
import { Helmet } from "react-helmet-async";

const SubCategory = () => {
  const dispatch = useDispatch()
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [search, setSearch] = useState("");
  const [data, setData] = useState([])
  const [mainData, setMainData] = useState([])
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [activeId, setActiveId] = useState(null)
  const [active, setActive] = useState(false)
  const [isLoader, setIsLoader] = useState(false); //loader

  const validationSchema = yup.object({
    subcategory: yup.string().required(),
    mainCategory: yup.object().required(),
  });

  const formik = useFormik({
    initialValues: {
      subcategory: "",
      mainCategory: null,
    },
    validationSchema: validationSchema,
    onSubmit: isEdit ? handleUpdate : handleCreate,
  });

  const onCreate = ()=>{
    setOpen(true)
    formik.resetForm()
    setIsEdit(false)
    }
    
    function handleCreate(){
      const subData = {
        subcategory_name: formik.values.subcategory,
        category_id: formik.values.mainCategory.id,
        subcategory_image: null,
        is_active : active
      }
      setIsLoader(true);
      axios.post('/v1/subcategories', subData)
      .then(res=>{
        setOpen(false)
        getSubCategoryData()
        dispatch(setSnackbar(true, 'success', 'Created Successfully'))
        setIsLoader(false);
      })
      .catch(err=>{
        dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
        setIsLoader(false);
      })
    }
    
    function onEdit(e){
    console.log(e)
    formik.setFieldValue('subcategory',e.categoryName)
    _.filter(mainData, val=>val.id===e.mainCat).map(val=>formik.setFieldValue('mainCategory', val))
    setIsEdit(true)
    setOpen(true)
    setActive(e.isActive)
    setActiveId(e.id)
    }
    
    function handleUpdate(){
      setIsLoader(true);
      const subData = {
        subcategory_name: formik.values.subcategory,
        category_id: formik.values.mainCategory.id,
        subcategory_image: null,
        is_active : active
      }
      axios.put(`/v1/subcategories/${activeId}`, subData)
      .then(res=>{
        setOpen(false)
        getSubCategoryData()
        dispatch(setSnackbar(true, 'success', 'Updated Successfully'))
        setIsLoader(false);
      })
      .catch(err=>{
        dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
        console.log(err)
        setIsLoader(false);
      })
    console.log('update')
    }
    
    function OnDelete(id){
      setOpenDialog(true)
      setActiveId(id)
    }  
    
    const handleDelete = () =>{
      setIsLoader(true);
      axios.delete(`/v1/subcategories/${activeId}`)
      .then(res=>{
        setOpenDialog(false)
        getSubCategoryData()
        dispatch(setSnackbar(true, 'success', 'Deleted Successfully'))
        setIsLoader(false);
        setOpen(false)
      })
      .catch(err=>{
        dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
        console.log(err)
        setIsLoader(false);
      })
      
    }

    const getCategoryData = () =>{
      setIsLoader(true);
      axios.get(`/v1/categories`)
      .then(res=>{
        setMainData(res.data)
        setIsLoader(false);
      })
      .catch(err=>{
        console.log(err)
        dispatch(setSnackbar(true, 'error', err.response.data.error))
        setIsLoader(false);
      })
    }

    
    const columns = [
      {
        field: "sno",
        headerName: "S.no",
        flex: 1,
        minWidth: 70,
        maxWidth: 100,
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
      {
        field: "categoryName",
        headerName: "Sub Category",
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
      {
        field: "mainCatName",
        headerName: "Main Category",
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
      {
        field: "active",
        headerName: "Status",
        disableExport: true ,
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
        disableColumnMenu: true,
        renderCell: (params) => (
          <div className="">
             <Chip size='small' color={params.row.isActive ? 'success' : 'error'} label={params.row.isActive ? 'Active' : 'Inactive'}/>
          </div>
        )
      },
      {
        field: 'action',
        headerName: 'Action',
        disableExport: true ,
        flex: 1,
        minWidth: 100,
        headerAlign: "center",
        align: "center",
        editable: false,
        sortable: false,
        disableColumnMenu: true,
        renderCell: (params) => (
          <div className='flex justify-center w-full'>
            <IconButton onClick={()=>onEdit(params.row)} >
              <EditNote sx={{color:"#1972d2",fontSize:22}}/>
            </IconButton>
            <IconButton onClick={() => OnDelete(params.id)}>
              <Delete sx={{color:"red",fontSize:22}}/>
            </IconButton>
          </div>
        ),
      },
    ];
  const rows = _.map(data,(val,idx)=>({
    id: val.id,
    sno: ++ idx,
    categoryName : val.subcategory_name,
    mainCat:val.category_id,
    mainCatName:val.category_name,
    isActive: val.is_active,

  }))

  const props = {
    rows: rows,
    columns: columns,
    search: search,
    setSearch: setSearch,
    page: page,
    setPage: setPage,
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage,
    pageCount: pageCount,
    pageOption: pageOption,
  };

  const getSubCategoryData = () =>{
    setIsLoader(true);
    const url = `/v1/subcategories/${rowsPerPage}/${page + 1}`
    const searchUrl = `/v1/subcategories/${rowsPerPage}/${page + 1}/${search}`
    axios.get(search === '' ? url : searchUrl)
    .then(res=>{
      setData(res.data.data)
      setPageCount(res.data.meta.pagination.total)
    })
    .catch(err=>{
      dispatch(setSnackbar(true, 'error', err.response.data.error))
    })
  }

useEffect(()=>{
  getSubCategoryData()
  getCategoryData()
},[rowsPerPage, page, search])
  return (
    <Fragment>
      <Helmet>
        <title>Sub Category</title>
      </Helmet>
      <Typography variant="h5">Sub Category</Typography>
      {!open && (
        <Grid className="flex justify-end">
          <Button variant="contained" size='small' onClick={onCreate}>
            Create New
          </Button>
        </Grid>
      )}
      {open && (
        <Modal onClose={setOpen} onSave={formik.handleSubmit} formik={formik} isEdit={isEdit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField id="subcategory" value={formik.values.subcategory} title="Sub Category" multiple={false} placeholder="Enter sub category" onchange={formik.handleChange} errorMsg={ formik.touched.subcategory &&  Boolean(formik.errors.subcategory) } helperText={formik.touched.subcategory && formik.errors.subcategory}/>
            </Grid>
            <Grid item xs={12} md={4} lg={3} >
              <CustomdropDown
                id="mainCategory"
                data={mainData}
                optionLabel={(option) => option.category_name}
                value={formik.values.mainCategory}
                onchange={(e, value) => {
                  formik.setFieldValue("mainCategory", value);
                }}
                optionEqual={(option, value) => option.category_name === value.category_name}
                placeholder="Select Main Category"
                helperText={formik.touched.mainCategory && formik.errors.mainCategory}
                errorMsg={
                  formik.touched.mainCategory && Boolean(formik.errors.mainCategory)
                }
                title="Main Category"
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3} className="flex items-center">
              <FormControlLabel control={<Checkbox checked={active} onChange={()=>setActive(!active)}/>} label="Active" />
            </Grid>
          </Grid>
        </Modal>
      )}
      <Grid className="bg-white rounded-md p-2 my-3">
        <CustomDataGrid props={props} />
      </Grid>
      <Backdrop open={openDialog} sx={{zIndex:1350}}>
  <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete}/>
</Backdrop>
{/* <Loader isLoader={isLoader} /> */}
    </Fragment>
  );
};

export default SubCategory;
